module.exports = __webpack_public_path__ + "static/media/logo-3d-ovato-coin-perspective-new.1a88cc71.pdf";